import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';

@Injectable({
  providedIn: 'root'
})
export class DashboardCreanceService {

  constructor(private _restClientService: RestClientService) { }


  nombreDossierContentieuxFiltrerSurPeriode() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-creance-restructure/nombre-dossier-creance-restructure-filtrerSurPeriode" 
    );
  }

  quantiteDossierContentieuxSurLes6DerniersMois() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-creance-restructure/quantite-dossier-creance-restructure-surLes6DerniersMois"
    );
  }

}
